import { supabase } from "@/lib/supabase"; // adjust path if needed
import type { SportType } from "@/types/data.types";
import { useQuery } from "@tanstack/react-query";

type UseRecentSportsOptions = {
  months?: number;
  limit?: number;
};

export function useRecentSports(options: UseRecentSportsOptions = {}) {
  const months = options.months ?? 6;
  const limit = options.limit ?? 6;

  return useQuery({
    queryKey: ["recent-sports", { months, limit }],
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    queryFn: async () => {
      const { data, error } = await supabase.rpc(
        "get_recent_sports_by_frequency",
        {
          months_back: months,
          limit_n: limit,
        }
      );

      if (error) throw error;

      const rows = (data ?? []) as Array<{
        sport_type: string;
        cnt: number | string;
      }>;

      const counts = rows
        .filter((r) => !!r.sport_type)
        .map((r) => ({
          sport: r.sport_type as SportType,
          count: typeof r.cnt === "string" ? Number(r.cnt) : r.cnt,
        }))
        .filter((r) => Number.isFinite(r.count));

      return {
        sports: counts.map((c) => c.sport),
        counts,
      };
    },
  });
}
